import { EOfficeType, Filters } from 'shared/types/filters';

export const includesManufactureType = (filters: Filters): boolean => {
  return filters.officeType.includes(EOfficeType.Manufacture);
};
